export const books = [
  {
    id: 1,
    title: "The Last Thing He Told Me: A Novel",
    author: "Laura Dave",
    img: "https://m.media-amazon.com/images/I/51G2Y+mbUpL._AC_UL320_.jpg",
  },
  {
    id: 2,
    title: "National Electrical Code 2020",
    author: "(NFPA) National Fire Protection Association",
    img: "https://m.media-amazon.com/images/I/41QQrauPygL._AC_UL320_.jpg",
  },

  {
    id: 3,
    title: "State of Terror: A Novel",
    author: "Louise Penny and Hillary Rodham Clinton",
    img: "https://m.media-amazon.com/images/I/71ogguMNzHS._AC_UL320_.jpg",
  },
];
